'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;

const tr = {
  'pt-BR': {
    send_error: 'Ocorreu um erro ao enviar. Tente novamente mais tarde.',
    sending: 'Enviando...',
    invalid_type: 'Apenas imagens JPG e PNG são permitidas.',
    max_files: count => `Você pode enviar apenas ${count} foto(s).`,
  },
  en: {
    send_error: 'An error occurred while sending. Please try again later.',
    sending: 'Sending...',
    invalid_type: 'Only JPG and PNG images are allowed.',
    max_files: count => `You can upload only ${count} file(s).`,
  },
  es: {
    send_error: 'Ocurrió un error al enviar. Inténtelo nuevamente más tarde.',
    sending: 'Enviando...',
    invalid_type: 'Solo se permiten imágenes JPG y PNG.',
    max_files: count => `Solo puedes enviar ${count} foto(s).`,
  },
};

const sendPhotos = {
  settings: {
    $form: $('.js-send-photos'),
    $submitButton: $('.js-submit-btn'),
    $invalidFeedback: $('.js-error'),
    $inputPhoto: $('.js-file-input'),
    submitButtonText: '',
    selectedFiles: [],
  },

  resetForm() {
    s.selectedFiles = [];
    s.$inputPhoto.val('');
    $('.js-preview-list').empty();
    s.$invalidFeedback.empty().hide();
  },

  sendStory() {
    s.$form.on('submit', function (e) {
      e.preventDefault();

      s.$submitButton.prop('disabled', true).text(tr[lang].sending);

      s.$invalidFeedback.empty().hide();

      const formData = new FormData();

      formData.append('_token', $('meta[name="csrf-token"]').attr('content'));

      Array.from(s.$inputPhoto[0].files).forEach(file => {
        formData.append('photo[]', file);
      });

      if ($('input[name="stage"]').length) {
        formData.append('stage', $('input[name="stage"]').val());
      }

      $.ajax({
        type: 'POST',
        url: s.$form.attr('action'),
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',

        success(response) {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              title: response.success,
            }).then(() => {
              _this.resetForm();
              window.location.reload();
            });

            return;
          }

          Swal.fire({
            icon: 'error',
            title: response.error,
          });
        },

        error(response) {
          if (response.status === 422) {
            s.$invalidFeedback.empty();

            $.each(response.responseJSON.errors, function (field, messages) {
              messages.forEach(message => {
                s.$invalidFeedback.append(`<div>${message}</div>`);
              });
            });

            s.$invalidFeedback.show();

            return;
          }

          Swal.fire({
            icon: 'error',
            title: tr[lang].send_error,
          });
        },

        complete() {
          s.$submitButton.prop('disabled', false).text(s.submitButtonText);
        },
      });
    });
  },

  initUpload() {
    const uploadContainer = document.querySelector('.c-upload');
    const uploadBox = document.querySelector('.js-upload-box');
    const input = document.querySelector('.js-file-input');
    const previewList = document.querySelector('.js-preview-list');
    const errorBox = document.querySelector('.js-error');

    if (!uploadContainer || !uploadBox || !input) {
      return;
    }

    const maxFiles = parseInt(uploadContainer.dataset.maxFiles || 5, 10);
    const alreadySent = parseInt(uploadContainer.dataset.alreadySent || 0, 10);

    const remainingFiles = maxFiles - alreadySent;

    const clearError = () => {
      errorBox.innerHTML = '';
    };

    const showError = message => {
      errorBox.innerHTML = message;
    };

    const renderPreview = () => {
      previewList.innerHTML = '';

      s.selectedFiles.forEach((file, index) => {
        const item = document.createElement('div');
        item.classList.add('c-upload__preview-item');

        const img = document.createElement('img');
        img.classList.add('c-upload__preview-image');
        img.src = URL.createObjectURL(file);

        const name = document.createElement('div');
        name.classList.add('c-upload__preview-name');
        name.textContent = file.name;

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.classList.add('c-upload__preview-remove');
        removeButton.innerHTML = '<i class="fa fa-trash"></i>';

        removeButton.addEventListener('click', () => {
          s.selectedFiles.splice(index, 1);

          updateInputFiles();
          renderPreview();
        });

        item.appendChild(img);
        item.appendChild(name);
        item.appendChild(removeButton);

        previewList.appendChild(item);
      });
    };

    const updateInputFiles = () => {
      const dt = new DataTransfer();

      s.selectedFiles.forEach(file => {
        dt.items.add(file);
      });

      input.files = dt.files;
    };

    const processFiles = files => {
      clearError();

      const newFiles = Array.from(files);

      const invalidFile = newFiles.find(file => {
        return !['image/jpeg', 'image/png'].includes(file.type);
      });

      if (invalidFile) {
        showError(tr[lang].invalid_type);
        return;
      }

      if (s.selectedFiles.length + newFiles.length > remainingFiles) {
        showError(tr[lang].max_files(remainingFiles));
        return;
      }

      s.selectedFiles = [...s.selectedFiles, ...newFiles];

      updateInputFiles();
      renderPreview();
    };

    uploadBox.addEventListener('click', () => {
      input.click();
    });

    input.addEventListener('change', e => {
      processFiles(e.target.files);
    });

    uploadBox.addEventListener('dragover', e => {
      e.preventDefault();
      uploadBox.classList.add('c-upload__dropzone--dragging');
    });

    uploadBox.addEventListener('dragleave', () => {
      uploadBox.classList.remove('c-upload__dropzone--dragging');
    });

    uploadBox.addEventListener('drop', e => {
      e.preventDefault();

      uploadBox.classList.remove('c-upload__dropzone--dragging');

      processFiles(e.dataTransfer.files);
    });
  },

  init() {
    this.initUpload();
    this.sendStory();
  },
};

const _this = sendPhotos;
const s = _this.settings;

s.submitButtonText = s.$submitButton.text();

export default sendPhotos;
